import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Modal } from '@mui/material';
import clsx from 'clsx';
import moment from 'moment';
import { DownloadFile } from 'actions';
import { useDispatch } from 'react-redux';

import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import DownloadIcon from '@mui/icons-material/Download';

const useStyles = makeStyles((theme) => ({
	root: {}
}));

const IncidentFilesTable = (props) => {
	const { data, ...rest } = props;
	const classes = useStyles();
	const rows = data || [];
	const dispatch = useDispatch();

	const getFileIcon = (filePath) => {
		const extension = filePath.split('.').pop().toLowerCase();
		switch (extension) {
						case 'jpeg':
							return <ImageSearchIcon />;
						case 'jpg':
							return <ImageSearchIcon />;
						case 'png':
							return <ImageSearchIcon />;
						case 'txt':
							return <ManageSearchIcon />;
						default:
							return <DownloadIcon />;
		}
	};

	const getFileNameWithExtension = (filePath) => {
		const parts = filePath.split('\\');
		const fileName = parts[parts.length - 1];
		return fileName;
	};

	const openFileInNewTab = (filePath, fileRender) => {
		const extension = filePath.split('.').pop().toLowerCase();
		const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
		if (extension === 'txt') {
			const newWindow = window.open();
			const { document } = newWindow;
			document.title = getFileNameWithExtension(filePath) || 'Blank Page';
			// Create a preformatted text element
			const pre = document.createElement('pre');
			// Set the text content
			pre.textContent = fileRender;
			// Append the preformatted text to the document body
			document.body.appendChild(pre);
		} else if (imageExtensions.includes(extension.toLowerCase())) {
			const newWindow = window.open();
			const { document } = newWindow;
			document.title = getFileNameWithExtension(filePath) || 'Blank Page';
			// Create an image element
			const img = document.createElement('img');
			// Set the source of the image to the Base64 string
			img.src = `data:image/jpeg;base64,${fileRender}`; // You may need to adjust the MIME type based on the image format
			// Append the image to the document body
			document.body.appendChild(img);
		} else {
			dispatch(DownloadFile(filePath));
		}
	};

	return (
		<div {...rest}>
			<TableContainer component={Paper}>
				<Table size="small" aria-label="a dense table">
					<TableBody>
						{rows.map((row) => (
							<TableRow
								key={row.name}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell sx={{ width: 150 }} align="left">{row.user}</TableCell>
								<TableCell sx={{ width: 150 }} align="left">{moment(row.date).format('YYYY-MM-DD HH:mm')}</TableCell>
								<TableCell align="left">{getFileNameWithExtension(row.filePath)}</TableCell>
								<TableCell align="center">
									<Button onClick={() => openFileInNewTab(row.filePath, row.fileRender)}>
										{getFileIcon(row.filePath)}
									</Button>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

IncidentFilesTable.propTypes = {
	data: PropTypes.array.isRequired,
};

export default IncidentFilesTable;
